import React from "react";
import Icon from "./Icon";

export function ToastViewport({ toasts = [], onDismiss }) {
  if (!toasts.length) return null;

  return (
    <div className="toast-viewport" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast toast-${toast.tone || "info"}`}>
          <div className="toast-body">
            <div className="toast-title">{toast.title}</div>
            {toast.description && <div className="toast-description">{toast.description}</div>}
            {toast.action && (
              <button
                type="button"
                className="toast-action"
                onClick={() => {
                  toast.action.onClick?.();
                  onDismiss?.(toast.id);
                }}
              >
                {toast.action.label}
              </button>
            )}
          </div>
          <button
            type="button"
            className="toast-close"
            aria-label="Dismiss notification"
            onClick={() => onDismiss?.(toast.id)}
          >
            <Icon name="x" size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastViewport;